import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getEnabledCockpitOfferings } from 'partner360/features/financialCockpit/lib'
import { selectCockpitOfferingsCatalog } from 'partner360/features/financialCockpit/model/selectors'

/** Display name for each enabled offering code — what the hierarchy tables' Product column needs
 *  to label its `level: 'offering'` nodes, since offering codes (`pc`, `supplies`, ...) are the one
 *  product level whose code isn't already a `jbp-*` i18n key. */
export const useOfferingNameByCode = (): Map<ProgramTypes, string> => {
  const offeringsCatalog = useSelector(selectCockpitOfferingsCatalog)

  return useMemo(
    () =>
      new Map(
        getEnabledCockpitOfferings(offeringsCatalog).map(({ offering, offeringName }) => [
          offering,
          offeringName,
        ])
      ),
    [offeringsCatalog]
  )
}
